export {
  type DurationTracker,
  createDurationTracker,
} from './duration-tracker';
